/* eslint-disable import/no-dynamic-require */
import { isKA } from '../../../common/config/utils';

export const getImageByEnvironment = (imageName, extension = '.svg') => require(`./${ isKA() ? 'ka' : 'pg' }/${ imageName }${ extension }`);
